export const extractApiErrorMessage = (
	errorData,
	fallbackMessage = "Ocorreu um erro inesperado."
) => {
	const errorPayload = Array.isArray(errorData)
		? errorData[0]
		: errorData;

	if (typeof errorPayload === "string") {
		return errorPayload;
	}

	return (
		errorPayload?.mensagem ||
		errorPayload?.message ||
		errorPayload?.erro ||
		(typeof errorPayload?.error === "string"
			? errorPayload.error
			: errorPayload?.error?.message || errorPayload?.error?.mensagem) ||
		fallbackMessage
	);
};

export const getResponseErrorMessage = async (
	response,
	fallbackMessage = "Ocorreu um erro inesperado."
) => {
	const errorData = await response.json().catch(() => null);

	return extractApiErrorMessage(errorData, fallbackMessage);
};

export const throwResponseError = async (
	response,
	fallbackMessage = "Ocorreu um erro inesperado."
) => {
	const errorMessage = await getResponseErrorMessage(response, fallbackMessage);

	throw new Error(errorMessage);
};